<template>
    <v-card flat class="site-title">
        <transition name="slide-fade">
            <v-card-title class="page-title" v-if="showTitle">Statistics</v-card-title>
        </transition>
    </v-card>
    <v-card flat class="site-wrapper">
        <v-btn rounded="lg" class="gradient-color-primary" :loading="loading" @click="calcStatistics">Neuen Datensatz erstellen</v-btn>
        <div v-if="loading && progress.totalSteps > 0" class="mt-4">
            <div class="d-flex justify-space-between align-center mb-2">
                <span class="text-body-2">{{ progress.currentStatisticName || 'Berechne Statistiken...' }}</span>
                <span class="text-body-2">{{ progress.currentStep }} / {{ progress.totalSteps }}</span>
            </div>
            <v-progress-linear
                :model-value="(progress.currentStep / progress.totalSteps) * 100"
                height="8"
                color="primary"
                rounded
            ></v-progress-linear>
        </div>
        <v-divider class="mt-4 mb-4"></v-divider>
        <div>
            <v-btn-toggle class="statistics-router-btn-group" variant="outlined" density="compact" rounded="lg">
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/lead-source' }"
                    @click="$router.push('/statistics/lead-source')">Lead Source</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/email-connections' }"
                    @click="$router.push('/statistics/email-connections')">Email Connections</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/table-statistics' }"
                    @click="$router.push('/statistics/table-statistics')">Kampagnen Statistiken</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/customer-statistics' }"
                    @click="$router.push('/statistics/customer-statistics')">Kunden Statistiken</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/agency-statistics' }"
                    @click="$router.push('/statistics/agency-statistics')">Agentur Statistiken</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/customer-login-statistics' }"
                    @click="$router.push('/statistics/customer-login-statistics')">Kunden Login Statistiken</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/whatsapp-connections' }"
                    @click="$router.push('/statistics/whatsapp-connections')">WhatsApp Connections</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/whatsapp-connections-per-agency' }"
                    @click="$router.push('/statistics/whatsapp-connections-per-agency')">WhatsApp Connections pro Agentur</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/whatsapp-messages' }"
                    @click="$router.push('/statistics/whatsapp-messages')">WhatsApp Messages</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/whatsapp-messages-per-agency-customer' }"
                    @click="$router.push('/statistics/whatsapp-messages-per-agency-customer')">WhatsApp Messages pro Agentur-Kunde</v-btn>
                <v-btn :class="{ 'gradient-color-secondary': $route.path === '/statistics/whatsapp-usage' }"
                    @click="$router.push('/statistics/whatsapp-usage')">WhatsApp Usage</v-btn>
            </v-btn-toggle>
        </div>
        <div>
            <router-view />
        </div>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            showTitle: false,
        };
    },
    computed: {
        ...mapState('statistics', ['loading', 'progress'])
    },
    methods: {
        ...mapActions('statistics', ['fetchStatistics']),
        async calcStatistics() {
            await this.fetchStatistics();
        }
    },
    mounted() {
        this.showTitle = true;
    }
}
</script>

<style lang="scss" scoped>

.statistics-router-btn-group {
    background-color: white;
    display: flex;
    white-space: nowrap;
    max-width: fit-content;
    overflow-x: auto;
}

</style>
